import {
  BffTrimData,
  ChargeTimeTrimModel,
  CostTrimModel,
  RangeTrimModel,
} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';
import {ConfigureButtonConfiguration} from '../types';

export function getConfigureButtonConfiguration(
  selectedTrim: BffTrimData<
    CostTrimModel | ChargeTimeTrimModel | RangeTrimModel
  >
): ConfigureButtonConfiguration {
  return {
    category: selectedTrim.category ?? 'private',
    carlineId: selectedTrim.carlineId,
    salesGroupId: selectedTrim.salesgroupId,
    trimName: selectedTrim.trimId,
  };
}
